// extracted by mini-css-extract-plugin
export default {"SectionAccordionWrapper":"SectionAccordionWrapper---MwF4o","SectionAccordionWrapper--dragging":"SectionAccordionWrapper--dragging---Fuh91","dragBtn":"dragBtn---kX64O"};